import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../../core/auth.service';
import { Router, Route } from "@angular/router";
import {environment} from '../../../../environments/environment';
const siteUrl = environment.serverURL;
@Component({
    selector: 'sam4-google-auth-button',
    templateUrl: './google-auth-button.component.html',
    styleUrls: ['./google-auth-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GoogleAuthButtonComponent implements OnInit {


    constructor(private auth: AuthService,private router: Router) {
    }
    public authUrl$: Observable<string> = this.auth.getGoogleAuthUrl$();
        //this.auth.getGoogleAuthUrl$(encodeURIComponent( siteUrl +  this.router.url.trim()));
    ngOnInit(): void {

    }

}
